import axios, { AxiosRequestConfig } from "axios";

export class ZoneApi {
  async getZoneList(searchText?: string) {
    const config: AxiosRequestConfig | undefined = searchText
      ? { params: { searchText } }
      : undefined;
    const response = await axios.get("/api/Zone", config);
    return response.data;
  }

  async getSubZoneList(zoneId: number, searchText?: string) {
    const config: AxiosRequestConfig | undefined = searchText
      ? { params: { searchText } }
      : undefined;
    const response = await axios.get(`/api/Zone/${zoneId}/SubZone`, config);
    return response.data;
  }
}
